import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import { Classes } from '@blueprintjs/core';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import React__default, { forwardRef } from 'react';
import cx from 'classnames';
import { omit } from 'ramda';

var _excluded = ["className", "children", "textValue", "onSelect", "type"],
    _excluded2 = ["children", "preventCloseOnSelect"],
    _excluded3 = ["children", "preventCloseOnSelect"];

var RadioWrapper = /*#__PURE__*/_styled("div", {
  target: "e1v7iphk0"
})("&.", Classes.CONTROL, ".", Classes.RADIO, ",&.", Classes.CONTROL, ".", Classes.CHECKBOX, "{padding-left:2.5rem !important;}");

var noop = function noop() {};

var Inner = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx, _ref2;

  var className = _ref.className,
      children = _ref.children,
      textValue = _ref.textValue;
      _ref.onSelect;
      var type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  var allOtherProps = omit(["onCheckedChange"], props);
  return /*#__PURE__*/React__default.createElement(RadioWrapper, _extends({
    className: cx(Classes.CONTROL, (_cx = {}, _defineProperty(_cx, Classes.RADIO, type === "radio"), _defineProperty(_cx, Classes.CHECKBOX, type === "checkbox"), _cx), className, Classes.MENU_ITEM)
  }, allOtherProps, {
    ref: ref
  }), /*#__PURE__*/React__default.createElement("input", {
    type: type,
    checked: !!props["aria-checked"],
    tabIndex: -1,
    onChange: noop
  }), /*#__PURE__*/React__default.createElement("span", {
    className: Classes.CONTROL_INDICATOR
  }), (_ref2 = children !== null && children !== void 0 ? children : textValue) !== null && _ref2 !== void 0 ? _ref2 : null);
});
var DropdownMenuRadioItem = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  _ref3.children;
      var _ref3$preventCloseOnS = _ref3.preventCloseOnSelect,
      preventCloseOnSelect = _ref3$preventCloseOnS === void 0 ? true : _ref3$preventCloseOnS,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React__default.createElement(RadixDropdownMenu.RadioItem, _extends({}, props, {
    asChild: true,
    ref: ref,
    onSelect: function onSelect(e) {
      var _props$onSelect;

      if (preventCloseOnSelect) {
        e.preventDefault();
      }

      (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, e);
    }
  }), /*#__PURE__*/React__default.createElement(Inner, _extends({
    type: "radio"
  }, props)));
});
var DropdownMenuCheckboxItem = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  _ref4.children;
      var _ref4$preventCloseOnS = _ref4.preventCloseOnSelect,
      preventCloseOnSelect = _ref4$preventCloseOnS === void 0 ? true : _ref4$preventCloseOnS,
      props = _objectWithoutProperties(_ref4, _excluded3);

  return /*#__PURE__*/React__default.createElement(RadixDropdownMenu.CheckboxItem, _extends({}, props, {
    asChild: true,
    ref: ref,
    onSelect: function onSelect(e) {
      var _props$onSelect2;

      if (preventCloseOnSelect) {
        e.preventDefault();
      }

      (_props$onSelect2 = props.onSelect) === null || _props$onSelect2 === void 0 ? void 0 : _props$onSelect2.call(props, e);
    }
  }), /*#__PURE__*/React__default.createElement(Inner, _extends({
    type: "checkbox"
  }, props)));
});

export { DropdownMenuCheckboxItem, DropdownMenuRadioItem };
//# sourceMappingURL=dropdown-menu-input-item.js.map
